export default "/fonts/vendor/primeicons/primeicons.svg?e1441b135b3ca9ad643ca8378d410731";